
import {
  defineComponent, reactive, watch,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import SelecionarCor from '@/core/components/Tela/SelecionarCor.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMatematico from '@/core/utilitarios/UtilitarioMatematico';
import { IProcessoProducaoEtapa } from '@/models/Entidades/Cadastros/PCP/IProcessoProducao';
import ServicoProcessoProducao from '@/servicos/Cadastros/PCP/ServicoProcessoProducao';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';

export default defineComponent({
  name: 'EtapaProcessoProducaoModal',
  props: {
    visivel: {
      type: Boolean,
    },
    editavel: {
      type: Boolean,
      default: true,
    },
    empresa: {
      type: Number,
      required: true,
    },
    processo: {
      type: Number,
      required: true,
    },
    etapa: {
      type: Object as () => IProcessoProducaoEtapa,
      required: true,
    },
  },
  components: {
    Icone,
    SelecionarCor,
  },
  emits: ['update:visivel', 'update:ultimoCodigoProvisorio', 'confirmacao'],
  setup(props, { emit }) {
    const { telaBase, apresentarMensagemAlerta, apresentarMensagemSucesso } = useTelaBase();
    const {
      modalBase, apresentarBarraProgresso, ocultarBarraProgresso, apresentarRetornoRequisicao,
    } = useModalBase(props, emit);
    const servicoProcessoProducao = new ServicoProcessoProducao();
    servicoProcessoProducao.requisicaoSistema();

    const state = reactive({
      etapa: {} as IProcessoProducaoEtapa,
    });

    function limparTela() {
      state.etapa = {} as IProcessoProducaoEtapa;
      state.etapa.codigoProcessoProducao = props.processo;
    }

    function validarCampos() {
      if (!UtilitarioGeral.valorValido(state.etapa.nome)) {
        apresentarMensagemAlerta('O nome é obrigatório!');
        return false;
      }
      if (!UtilitarioGeral.valorValido(state.etapa.cor)) {
        apresentarMensagemAlerta('A cor é obrigatória!');
        return false;
      }
      return true;
    }

    async function salvar() {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };

      if (!validarCampos()) {
        return;
      }

      apresentarBarraProgresso();
      retorno = await servicoProcessoProducao.atualizarEtapa(props.empresa, state.etapa);
      ocultarBarraProgresso();

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        emit('confirmacao');
        apresentarMensagemSucesso(retorno.mensagem);
        modalBase.computedVisivel = false;
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    watch(async () => modalBase.computedVisivel, async () => {
      telaBase.carregando = true;
      limparTela();
      if (modalBase.computedVisivel) {
        if (props.etapa.codigo !== undefined) {
          state.etapa = UtilitarioGeral.clonarObjeto(props.etapa);
        }
      }
      telaBase.carregando = false;
    });

    return {
      props,
      state,
      telaBase,
      modalBase,
      UtilitarioMatematico,
      salvar,
    };
  },
});
